"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentText = void 0;
var rich_content_text_1 = require("./rich-content-text");
Object.defineProperty(exports, "RichContentText", { enumerable: true, get: function () { return rich_content_text_1.RichContentText; } });
